export default __webpack_public_path__ + "static/media/fw-isabella-er-Yellow Gold.d5b551cb.mp4";